'use client'

import { SelectedCardProvider } from '../contexts/SelectedCardContext'
import { useUserCards } from '../hooks/useUserCards'
import { CardDashboard } from './CardDashboard'

interface CardTabsProps {
  onAuthenticationFailed?: () => void
  maxCards?: number
}

export function CardTabs({ onAuthenticationFailed, maxCards }: CardTabsProps) {
  const { cards } = useUserCards()

  return (
    <SelectedCardProvider cards={cards}>
      <CardDashboard onAuthenticationFailed={onAuthenticationFailed} maxCards={maxCards} />
    </SelectedCardProvider>
  )
}
